//components
import { BasicButton, InformationContainer, SimpleTable } from "thrive-components";
import RemovePasskeysModal from "@/components/modals/passkeys/RemovePasskeys";
import NotificationBar from "@/components/elements/languages/NotificationBar";

//hook
import UseManageYourPasskeysPage from "./ManageYourPasskeysPage.hooks";
import { getLoginRelativePath } from "@/helpers/Auth";

//styling
import "../../../css/manage/manage-your-passkeys.scss";



const ManageYourPasskeysPage = () => {  
    const {addPasskeyLink, selectedPasskey, setSelectedPasskey, onRemovePasskeyClick, tableData, notificationDetails, hasPasskeyButIsntUsingIt} = UseManageYourPasskeysPage();

    return(
        <div className="mange-your-passkeys-page">
            <div className="manage-your-passkeys-header">
                <h1 className='manage-your-passkeys-title'>Manage your Passkeys</h1>

                <BasicButton 
                    className={`add-passkey-button `}
                    content={"Add Passkey"} 
                    ariaLabel={"Add a new passkey"}
                    isLink
                    linkUrl={addPasskeyLink}
                    isDisabled={hasPasskeyButIsntUsingIt}
                />
            </div>

            {hasPasskeyButIsntUsingIt &&
                <InformationContainer className={'logged-in-without-a-passkey-info'} type={"info"}>
                    <div className="info-content-wrapper">
                        <span className="info-text">You're currently signed in without a passkey. Sign in with a passkey to manage passkeys</span>
                        <BasicButton 
                            className={`sign-in-with-passkey-button`}
                            content={"Sign in with Passkey"} 
                            ariaLabel={"Sign in with Passkey"}
                            isLink
                            linkUrl={getLoginRelativePath()}
                        />
                    </div>
                </InformationContainer>
            }
                
            <SimpleTable 
                {...tableData}
            />
           
            <RemovePasskeysModal 
                showModal={!!selectedPasskey} 
                hideModal={() => setSelectedPasskey(null)} 
                passkeyName={selectedPasskey?.name ?? ""} 
                onRemovePasskeyClick={onRemovePasskeyClick}
                isLoggedInCredential={selectedPasskey?.isLoggedInCredential}
            />

            {notificationDetails && (
                    <NotificationBar 
                        show={notificationDetails?.show} 
                        notificationStatus={notificationDetails?.status} 
                        msg={notificationDetails?.message} 
                    />
                )
            }
        </div>
    )
}
export default ManageYourPasskeysPage 